import { graphql } from "gatsby";
import React, { FC, useRef } from "react";

import { HeroSlider, HeroSliderItem } from "../../sliders/hero-slider";

export interface HeroSliderSectionProps extends Queries.HeroSliderSectionDataFragment {}

export const HeroSliderSection: FC<HeroSliderSectionProps> = ({ slides }) => {
  const heroRef = useRef<HTMLDivElement>(null);

  const handleScrollDown = () => {
    if (typeof window !== "undefined") {
      window.scrollTo({
        top: (heroRef.current?.offsetTop ?? 0) + (heroRef.current?.clientHeight ?? 0),
        behavior: "smooth",
      });
    }
  };

  return (
    <div ref={heroRef}>
      <HeroSlider
        slides={(slides ?? []).filter(Boolean).map<HeroSliderItem>((slide) => ({
          id: slide!.id,
          image: slide!.image?.gatsbyImageData ?? undefined,
          video: slide!.video?.url ?? undefined,
          titleTop: slide!.titleTop ?? undefined,
          titleBottom: slide!.titleBottom ?? undefined,
        }))}
        onScrollDown={handleScrollDown}
      />
    </div>
  );
};

export const query = graphql`
  fragment HeroSliderSectionData on ContentfulHeroSliderSection {
    slides {
      id
      image {
        gatsbyImageData
      }
      video {
        placeholderUrl
        url
      }
      titleTop
      titleBottom
    }
  }
`;
